import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { cn } from '../utils/cn';
const TabsContext = createContext(undefined);
export function Tabs({ defaultValue, value: controlledValue, onValueChange, className, children, ...props }) {
    const [internalValue, setInternalValue] = useState(defaultValue || '');
    const value = controlledValue ?? internalValue;
    const handleValueChange = (newValue) => {
        if (controlledValue === undefined)
            setInternalValue(newValue);
        onValueChange?.(newValue);
    };
    return (_jsx(TabsContext.Provider, { value: { value, onValueChange: handleValueChange }, children: _jsx("div", { className: className, ...props, children: children }) }));
}
export function TabsList({ className, ...props }) {
    return (_jsx("div", { className: cn('inline-flex items-center gap-1 p-1 rounded-xl bg-gray-100 dark:bg-gray-800', className), ...props }));
}
export function TabsTrigger({ value, className, ...props }) {
    const context = useContext(TabsContext);
    if (!context)
        throw new Error('TabsTrigger must be used within Tabs');
    const isActive = context.value === value;
    return (_jsx("button", { className: cn('inline-flex items-center justify-center whitespace-nowrap rounded-lg px-4 py-2 text-sm font-medium transition-all duration-200', isActive
            ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300', className), onClick: () => context.onValueChange(value), "data-state": isActive ? 'active' : 'inactive', ...props }));
}
export function TabsContent({ value, className, ...props }) {
    const context = useContext(TabsContext);
    if (!context)
        throw new Error('TabsContent must be used within Tabs');
    if (context.value !== value)
        return null;
    return (_jsx("div", { className: cn('mt-3 animate-fade-in-up', className), ...props }));
}
